import ebimbingan from "../asset/ebimbingan.png";

const DEFAULT_TITLE = "Penyelenggaraan Sedang Berjalan";
const DEFAULT_WORDING =
  "Portal Permohonan e-Bimbingan sedang dalam penyelenggaraan buat sementara waktu.\n\nHarap maaf atas sebarang kesulitan. Sila cuba semula kemudian.";

export function Maintenance({ title, wording }) {
  const displayTitle = title?.trim() || DEFAULT_TITLE;
  const displayWording = wording?.trim() || DEFAULT_WORDING;

  return (
    <div className="flex h-screen items-center justify-center bg-cover bg-center bg-gray-100">
      <div className="border-primaryBorder shadow-default m-auto w-full max-w-md rounded-lg border bg-white px-6 py-8 text-center sm:max-w-md">
        <img src={ebimbingan} className="mx-auto mb-6" alt="eBimbingan Logo" />
        <h1 className="text-primary mb-4 text-2xl font-bold">{displayTitle}</h1>
        <p className="text-md mb-6 whitespace-pre-line text-gray-600">
          {displayWording}
        </p>

        <div className="text-sm text-gray-500">
          © {new Date().getFullYear()} e-Bimbingan. Semua Hak Cipta Terpelihara.
        </div>
      </div>
    </div>
  );
}

export default Maintenance;
